import { professionalMap } from "./professional";
import { timestampsMap } from "./timestamps";

export const teamMap: GenericObject = {
	nome: "name",
	especialidade_id: "expertiseId",
	membros: {
		__key: "members",
		...professionalMap,
	},
	...timestampsMap,
};
